// extracted by mini-css-extract-plugin
export var pillWrapper = "_gi-0";
export var showOverflow = "_gi-1";